export function childErrors (childKey, errors) {
  return errors.filter(e => e.loc[0] == childKey).map(
    e => ({
      ...e,
      loc: e.loc.slice(1),
    })
  )
}
